/**
 * The chat wallpaper pattern: WhatsApp's line-art doodles, as a repeating SVG
 * tile.
 *
 * ★ THE PATTERN IS A MASK, NOT A PICTURE.
 * The tile is drawn in a single flat colour and used as `mask-image`, so the
 * colour that actually shows is the `wa.doodle` token behind it — which flips
 * with the colour mode and never puts a hex into a component. A background
 * image would have needed one tile per mode and a literal in each.
 *
 * Twelve small strokes on a 420px grid, spaced unevenly so the repeat does not
 * read as a grid. Everything is stroked, nothing filled, to stay as quiet as
 * the original.
 */
const STROKE = 'stroke="black" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"';

const shapes = [
	// chat bubble
	`<path d="M40 52c0-9 7-16 16-16h26c9 0 16 7 16 16v10c0 9-7 16-16 16H66l-14 10v-10c-7-1-12-8-12-16z" ${STROKE}/>`,
	// heart
	`<path d="M180 70c-10-14-30-6-26 10 3 11 26 26 26 26s23-15 26-26c4-16-16-24-26-10z" ${STROKE}/>`,
	// star
	`<path d="M320 40l7 15 17 2-12 12 3 17-15-8-15 8 3-17-12-12 17-2z" ${STROKE}/>`,
	// phone
	`<path d="M70 190c-6-8-10-22-3-30l8-6 12 16-8 7c3 8 10 15 18 18l7-8 16 12-6 8c-8 7-22 3-30-3-6-4-10-8-14-14z" ${STROKE}/>`,
	// note
	`<path d="M200 170h44v38l-12 12h-32z M232 208v12h12" ${STROKE}/><path d="M212 188h20M212 198h14" ${STROKE}/>`,
	// camera
	`<path d="M300 180h14l6-8h20l6 8h14v36h-60z" ${STROKE}/><circle cx="330" cy="198" r="9" ${STROKE}/>`,
	// pin
	`<path d="M120 300c0-12 9-20 20-20s20 8 20 20c0 14-20 32-20 32s-20-18-20-32z" ${STROKE}/><circle cx="140" cy="300" r="6" ${STROKE}/>`,
	// coffee cup
	`<path d="M240 300h44v22c0 10-8 18-18 18h-8c-10 0-18-8-18-18z M284 306h8c6 0 10 4 10 9s-4 9-10 9h-8" ${STROKE}/><path d="M252 288c0-4 4-4 4-8M264 288c0-4 4-4 4-8" ${STROKE}/>`,
	// smiley
	`<circle cx="360" cy="320" r="20" ${STROKE}/><path d="M352 328c4 5 12 5 16 0" ${STROKE}/><circle cx="353" cy="314" r="1.6" fill="black"/><circle cx="367" cy="314" r="1.6" fill="black"/>`,
	// music note
	`<path d="M30 400v-38l30-8v38" ${STROKE}/><circle cx="24" cy="402" r="6" ${STROKE}/><circle cx="54" cy="394" r="6" ${STROKE}/>`,
	// sun
	`<circle cx="400" cy="110" r="11" ${STROKE}/><path d="M400 90v-6M400 130v6M420 110h6M380 110h-6M414 96l4-4M386 124l-4 4M414 124l4 4M386 96l-4-4" ${STROKE}/>`,
	// envelope
	`<path d="M150 400h50v32h-50z M150 400l25 18 25-18" ${STROKE}/>`,
];

const SVG =
	`<svg xmlns="http://www.w3.org/2000/svg" width="420" height="420" viewBox="0 0 420 420">${shapes.join('')}</svg>`;

/** A `url(...)` value for `mask-image`, built once. */
export const DOODLE_MASK = `url("data:image/svg+xml;utf8,${encodeURIComponent(SVG)}")`;

export const DOODLE_TILE = '320px';
